module.exports = __webpack_public_path__ + "static/media/cardTwo.b3acf780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardTwo.jpg
// module id = 84
// module chunks = 0